// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete,
    Avatar
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';
import React from 'react';
import AttachmentFab from '../../../../components/attachment/AttachmentFab';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [file, setFile] = useState<any>(null)
    const [txtFile, setTxtFile] = useState<any>(null)

    const [valBarang, setValBarang] = useState<any>(null)
    const [listBarang, setListBarang] = useState<any[]>([])

    const [valCustomer, setValCustomer] = useState<any>(null)
    const [listCustomer, setListCustomer] = useState<any[]>([])

    useEffect(() => {
        getDetail()
    }, [])

    const navigate = useNavigate();

    const getDetail = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/sales/leads/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    setValue('syscabang_id', data.syscabang_id)
                    setValue('sdcust_id', data.sdcust_id)
                    setValue('nama_customer', data.nama_customer)
                    setValue('tgl', data.tgl?.substring(0, 10))
                    setValue('tgl_max', data.tgl_max?.substring(0, 10))
                    setValue('keterangan', data.keterangan)
                    setValue('jenis_barang_id', data.jenis_barang_id)
                    setValue('link', data.link)

                    getCustomer(data.sdcust_id)
                    getBarang(data.jenis_barang_id)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getCustomer = (ids: any) => {
        const url = apiUrl.apiUrl + '/sales/customer/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (String(element.id) == String(ids)) {
                            setValCustomer(element)
                        }
                    });
                    setListCustomer(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getBarang = (ids: any) => {
        const url = apiUrl.apiUrl + '//mm/jenis-barang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValBarang(element)
                        }
                    });
                    setListBarang(data)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleChangeAutocompleteCustomer = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdcust_id', newValue?.id)
        setValue('nama_customer', newValue?.nama)
        setValCustomer(newValue)
    }
    const handleChangeAutocompleteJenisBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('jenis_barang_id', newValue?.id)
        setValBarang(newValue)
    }

    interface FormInputs {
        syscabang_id: any,
        sdcust_id: any,
        nama_customer: string,
        tgl: any,
        tgl_max: any,
        jenis_barang_id: any,
        keterangan: string,
        file: any
        link: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        file: null
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    // UPLOAD ATTACHMENT
    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const handleClick = (event: any) => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }

    const handleFile = async (event: any) => {
        const files = event.target.files[0]
        const nameFiles = files.name
        // const image = await resizeFile(files)
        setFile(files)
        setTxtFile(nameFiles)
        setValue('file', files)
    }


    const tampilkanGambar = (url: string) => {
        if (
            url != '' &&
            url !=
            'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        ) {
            Swal.fire({
                imageUrl: url,
                imageAlt: 'Gambar'
            })
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Pemberitahuan',
                text: 'Gambar Tidak Tersedia'
            })
        }
    }

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const bodyFormData = new FormData()
                bodyFormData.append('syscabang_id', data.syscabang_id)
                bodyFormData.append('tgl_max', data.tgl_max)
                bodyFormData.append('tgl', data.tgl)
                bodyFormData.append('sdcust_id', data.sdcust_id)
                bodyFormData.append('keterangan', data.keterangan)
                bodyFormData.append('sdcust_id', data.jenis_barang_id)
                bodyFormData.append('nama_customer', data.nama_customer)
                bodyFormData.append('file', data.file)

                const url = apiUrl.apiUrl + '/sales/leads/edit/' + id
                axios
                    .post(url, bodyFormData, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    const id = response.data.data
                                    navigate('/sales/leads/detail/' + id)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Leads
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Customer
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sdcust_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valCustomer}
                                                options={listCustomer}
                                                id='sdcust_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteCustomer}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Customer'
                                                        error={Boolean(errors.sdcust_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sdcust_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Jenis Barang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jenis_barang_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valBarang}
                                                options={listBarang}
                                                id='jenis_barang_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteJenisBarang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Jenis Barang'
                                                        error={Boolean(errors.sdcust_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.jenis_barang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Tanggal
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tanggal'
                                                type='date'
                                                error={Boolean(errors.tgl)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Tanggal Max Follow Up
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_max'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tanggal Max Follow Up'
                                                type='date'
                                                error={Boolean(errors.tgl_max)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tgl_max && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Upload Gambar
                                </Typography>
                                <input
                                    type='file'
                                    ref={hiddenFileInput}
                                    onChange={handleFile}
                                    style={{ display: 'none' }}
                                    accept='image/png, image/jpg, image/jpeg'
                                ></input>
                                <FormControl fullWidth>
                                    <Controller
                                        name='file'
                                        control={control}
                                        rules={{ required: getValues('link') == null ? true : false }}
                                        render={({ field: { value, onChange } }) => (
                                            <>
                                                <InputLabel htmlFor='input-file'>Gambar</InputLabel>
                                                <OutlinedInput
                                                    label='Foto'
                                                    value={txtFile}
                                                    id='input-file'
                                                    type={'text'}
                                                    error={Boolean(errors.file)}
                                                    startAdornment={
                                                        <Box
                                                            onClick={handleClick}
                                                            onMouseDown={e => e.preventDefault()}
                                                            sx={{ cursor: 'pointer' }}
                                                        >
                                                            <InputAdornment position='start'>
                                                                Pilih Gambar &nbsp;
                                                                <IconButton edge='start' aria-label='paperclip'>
                                                                    <Icon fontSize={20} icon={'mdi:paperclip'} />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        </Box>
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                    {errors.file && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                                    Lihat Gambar
                                </Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                    <Tooltip title='Preview Design' placement='top'>
                                        <Controller
                                            name='link'
                                            control={control}
                                            rules={{ required: false }}
                                            render={({ field: { value, onChange } }) => (
                                                <>

                                                    <Box sx={{ cursor: 'pointer' }} onClick={() => tampilkanGambar(value)}>
                                                        <Avatar alt='Thumbnail' sx={{ width: 50, height: 50 }} src={value} />
                                                    </Box>
                                                    {/* <Typography variant='caption'>
                                                            &nbsp; {value}
                                                        </Typography> */}
                                                </>
                                            )}
                                        />
                                    </Tooltip>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Keterangan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>

            <AttachmentFab
                docId={Number(id)}
                docType="sdleads"
            />
        </Grid>
    )
}
